// src/i18n/it/views/dominioPropio.js
// Traducción al italiano de la guía que ve el anfitrión para apuntar su dominio
// a la web del constructor. Marcadores que rellena la pantalla y NO se traducen:
// {dominio} {destino} {nombre} {tipo} {valor} {encontrado} {actual} {sitio} {panel} {panelCorto} {paso}

export const dominioPropio = {
  cabecera: {
    titulo: "Collega il tuo dominio",
    subtitulo:
      "Il tuo sito adesso si vede su {actual}. Alla fine si vedrà sul tuo indirizzo di sempre.",
    duracion: "Dieci minuti di lavoro tuo. Il resto lo fa internet da solo.",
  },

  // ── I tre passi ────────────────────────────────────────────────────────────
  pasos: {
    uno: "Il tuo dominio",
    dos: "Le due annotazioni su {panelCorto}",
    tres: "Verifica",
    unoDetalle: "Scrivi l'indirizzo che vuoi usare",
    dosDetalle: "Copi due righe nel pannello del tuo dominio",
    tresDetalle: "Noi verifichiamo che sia tutto a posto",
    indicador: "Passo {paso} di 3",
  },

  // ── Paso 1 ─────────────────────────────────────────────────────────────────
  paso1: {
    titulo: "Quale indirizzo vuoi per il tuo sito?",
    descripcion:
      "Scrivi il dominio che hai già comprato. Noi non vendiamo domini: qui colleghi uno che è già tuo.",
    etiqueta: "Il tuo dominio",
    marcador: "miodominio.com",
    ayuda: "Scrivilo così com'è, senza «https://» e senza barre alla fine.",

    formaTitulo: "E come vuoi che si legga?",
    formaRaiz: {
      titulo: "miodominio.com",
      descripcion: "L'indirizzo corto, senza niente davanti. È il più comune.",
    },
    formaWww: {
      titulo: "www.miodominio.com",
      descripcion: "Quello di sempre, con «www» davanti.",
    },
    formaSubdominio: {
      titulo: "prenotazioni.miodominio.com",
      descripcion:
        "Un indirizzo a parte, per non toccare il sito che hai già su {dominio}.",
    },
    subdominioEtiqueta: "La parola che va davanti",
    subdominioMarcador: "prenotazioni",
    subdominioAyuda: "Solo la parola. Il resto lo mettiamo noi.",

    avisoWebExistente: {
      titulo: "Hai già un sito a quell'indirizzo?",
      texto:
        "Se oggi {dominio} mostra un altro sito, alla fine non si vedrà più e si vedrà questo. Se preferisci tenerlo, usa un indirizzo a parte come prenotazioni.{dominio}.",
    },

    boton: "Continua",
    botonComprobando: "Verifica del dominio in corso…",
  },

  // ── Dove ha il dominio ─────────────────────────────────────────────────────
  proveedor: {
    pregunta: "Dove hai comprato o dove gestisci {dominio}?",
    ayuda:
      "È l'azienda a cui paghi il rinnovo ogni anno. Se non te lo ricordi, cerca nella tua email l'ultima fattura del dominio.",
    cloudflare: "Cloudflare",
    cloudflareDetalle: "Istruzioni complete, schermata per schermata",
    otro: "Un'altra azienda",
    otroDetalle: "GoDaddy, IONOS, Namecheap, Aruba…",
    otroTexto:
      "Le annotazioni sono esattamente le stesse. Cambia solo dove si trova il pulsante. Cerca nel tuo pannello qualcosa che dica «DNS», «Zona DNS» o «Gestione DNS» e copia lì le righe della tabella qui sopra, una per una.",
    noLoSe: "Non lo so",
    noLoSeTexto:
      "Scrivici indicando il tuo dominio e ti diciamo dov'è e cosa bisogna toccare.",
  },

  // ── Paso 2 ─────────────────────────────────────────────────────────────────
  paso2: {
    titulo: "Adesso devi dire al tuo dominio dov'è il tuo sito",
    descripcion:
      "Il tuo dominio è un nome. Da solo non porta da nessuna parte: qualcuno deve annotare su una rubrica che quel nome corrisponde al nostro server. Quella rubrica si chiama DNS ed è nel pannello del tuo dominio.",

    queEsUnRegistro: {
      titulo: "Cosa farai esattamente",
      texto:
        "Aggiungerai una riga a quella rubrica. Una sola. Ha tre spazi da riempire: come si chiama, dove punta e se passa o no da un filtro. Nient'altro.",
      textoOtro:
        "Aggiungerai delle righe a quella rubrica. Ognuna ha due spazi da riempire: come si chiama e dove punta. Nient'altro.",
    },

    copiaTitulo: "Copia questi dati così come sono",
    copiaAyuda:
      "Usa i pulsanti per copiare. Uno spazio in più o una lettera sbagliata e non funziona.",

    tabla: {
      tipo: "Tipo",
      nombre: "Nome",
      destino: "Destinazione",
      contenido: "Contenuto",
      proxy: "Stato del proxy",
      ttl: "TTL",
      valorProxy: "Solo DNS (nuvola grigia)",
      valorTtl: "Auto",
    },

    copiar: "Copia",
    copiado: "Copiato",
    copiarTodo: "Copia i dati",

    tipos: {
      cnameTitulo: "CNAME",
      cnameTexto:
        "È un rinvio: dice che il tuo dominio si serve da {destino}. Se un giorno cambiamo server, tu non devi toccare niente.",
      txtTitulo: "TXT",
      txtTexto:
        "È una nota firmata. Non porta da nessuna parte: dimostra solo che il dominio è tuo. La puoi cancellare quando il sito funziona, ma è più comodo lasciarla dov'è.",
    },

    nombreTitulo: "Cosa si scrive in «Nome»",
    nombreRaiz:
      "Per il dominio corto ({dominio}) scrivi una chiocciola: @. Nella rubrica del DNS la chiocciola significa «il dominio e basta, senza niente davanti». Non scrivere {dominio} per intero.",
    nombreWww: "Per www.{dominio} scrivi solo: www",
    nombreSubdominio:
      "Per {nombre}.{dominio} scrivi solo la parola davanti: {nombre}",
    nombreAviso:
      "Su Cloudflare scrivi solo quella parte. Lui aggiunge «.{dominio}» da solo e te lo mostra sotto al campo.",
    nombreAvisoOtro:
      "In quasi tutti i pannelli si scrive solo quella parte e sono loro ad aggiungere «.{dominio}». Se il tuo ti chiede il nome per intero, scrivi {nombre}.{dominio}.",
    nombreAvisoOtroRaiz:
      "Se il tuo pannello non accetta «@», lascia il nome vuoto: in molti vuol dire la stessa cosa, il dominio senza niente davanti.",

    volver: "L'ho già fatto, torna a WACheckin",
    ayudaEnviar: "Inviami questi dati via email",
    ayudaEnviarTexto:
      "Se lo farà il tuo tecnico o chi ti ha curato il sito, ti mandiamo le istruzioni via email così gliele inoltri.",
  },

  // ── Cloudflare, passo per passo ────────────────────────────────────────────
  cloudflare: {
    titulo: "Fallo su Cloudflare",
    subtitulo:
      "Dieci minuti. Tieni a portata di mano l'email e la password di Cloudflare.",

    pasos: {
      uno: "Entra su dash.cloudflare.com con il tuo account.",
      dos: "Nella prima schermata compaiono i tuoi domini. Clicca su {dominio}.",
      tres:
        "Nel menu di sinistra apri «DNS» e poi «Record» («Records»).",
      cuatro:
        "Vedrai un elenco con le righe che hai già. Clicca sul pulsante «Aggiungi record» («Add record»).",
      cinco: "In «Tipo» («Type») scegli {tipo} nel menu a tendina.",
      seis: "In «Nome» («Name») scrivi {nombre}",
      siete: "In «Destinazione» («Target») incolla {valor}",
      ocho:
        "In «Stato del proxy» («Proxy status») clicca sulla nuvola arancione. Deve diventare grigia e dire «Solo DNS» («DNS only»).",
      nueve: "Lascia «TTL» su «Auto». Non toccarlo.",
      diez: "Clicca su «Salva» («Save»).",
      once:
        "Se la tabella qui sopra ha più di una riga, ripeti dal passo 4 con la successiva.",
    },

    hecho: "Fatto. Torna su WACheckin e clicca su «Verifica».",

    avisoAntes: {
      titulo: "Prima di salvare, leggi qui",
      texto:
        "Cloudflare mette quella nuvola in arancione da solo, senza chiedere. Se la lasci arancione, il collegamento non funzionerà. Il passo 8 è quello importante di tutta questa schermata.",
    },

    accesoNegado: {
      titulo: "Non riesci a entrare su Cloudflare?",
      texto:
        "Di solito l'account è intestato a chi ti ha realizzato il sito. Chiedigli di fare questi passi o di aggiungerti come membro del dominio.",
    },
  },

  // ── La nuvola arancione ────────────────────────────────────────────────────
  proxy: {
    titulo: "La nuvola arancione: è quasi sempre questo il problema",
    queEs:
      "Accanto a ogni riga del DNS, Cloudflare mostra una nuvoletta. Arancione vuol dire che il traffico passa prima da Cloudflare. Grigia vuol dire che va dritto.",
    porQueFalla:
      "Con la nuvola arancione, quando qualcuno chiede del tuo dominio Cloudflare non risponde {destino}: risponde con i propri indirizzi. La nostra verifica chiede, vede Cloudflare e non trova l'annotazione che ti avevamo chiesto. Anche se tu l'hai scritta bene, per noi è come se non esistesse.",
    porQueFalla2:
      "E c'è una seconda conseguenza peggiore: il lucchetto di sicurezza del tuo sito si rilascia verificando che il dominio arrivi fino a noi. Con la nuvola arancione non arriva, quindi non si può rilasciare e il browser avviserà che il sito non è sicuro.",
    comoSeArregla:
      "Clicca sulla nuvola. Diventa grigia e il testo accanto cambia in «Solo DNS» («DNS only»). Salva. Tutto qui.",
    grisEsSeguro:
      "Metterla in grigio non lascia il tuo sito senza protezione. Il tuo sito lo serviamo noi, con il suo certificato e dietro la nostra protezione. Cloudflare stava in mezzo solo per come era configurato di serie.",
    ttlBloqueado:
      "Un dettaglio che confonde parecchio: finché la nuvola è arancione, Cloudflare non ti lascia toccare il TTL. Quando la metti in grigio si sblocca. Lascialo su «Auto».",
    etiquetaProxied: "Con proxy («Proxied»), nuvola arancione: NO",
    etiquetaSoloDns: "Solo DNS («DNS only»), nuvola grigia: SÌ",
  },

  // ── Il dominio corto (radice) ──────────────────────────────────────────────
  raiz: {
    titulo: "Se usi il dominio corto: non devi fare niente di speciale",
    texto:
      "C'è una vecchia regola di internet che dice che il dominio corto ({dominio}, senza niente davanti) non accetta questo tipo di annotazione. Con la maggior parte delle aziende questo obbliga a fare giri strani.",
    flattening:
      "Cloudflare lo risolve da solo. Quando il «Nome» è @, applica una cosa sua chiamata CNAME flattening: salva il tuo rinvio e, quando qualcuno chiede, risponde già con l'indirizzo finale. Tu non devi attivare niente, è attivo in tutti i piani, compreso quello gratuito.",
    avisoAjusteGlobal:
      "Una cosa invece conviene: non toccare l'opzione «CNAME flattening for all CNAME records», in «DNS» → «Impostazioni» («Settings»). Applicata a tutto, smette di rispondere ai rinvii così come sono scritti e rompe le verifiche di proprietà degli altri servizi che hai: email, Google, il negozio online…",
    tituloOtro: "Se usi il dominio corto ({dominio})",
    textoOtroA:
      "Sul dominio senza niente davanti vanno righe di tipo A, quelle della tabella. Le accettano tutte le aziende.",
    textoOtroCname:
      "Molte aziende non permettono di mettere un CNAME sul dominio senza niente davanti. Se la tua non ti lascia salvare quella riga, usa «www» o un indirizzo a parte come prenotazioni.{dominio}, oppure scrivici e lo risolviamo insieme a te.",
    conflicto: {
      titulo: "Se il dominio corto aveva già qualcosa",
      texto:
        "Uno stesso nome non può avere due destinazioni insieme. Se nell'elenco c'è già una riga di tipo A o CNAME con il «Nome» su @ (o su «www», se userai www), cancellala prima di aggiungere la nostra. Cloudflare ti avviserà se non lo fai.",
      textoOtro:
        "Uno stesso nome non può avere due destinazioni insieme. Se nel tuo pannello c'è già una riga di tipo A o CNAME con lo stesso nome, cancellala prima di aggiungere la nostra.",
      comoBorrar:
        "Passa il mouse sopra quella riga, clicca su «Modifica» («Edit») e poi su «Elimina» («Delete»).",
      apunta:
        "Segnati su un foglio cosa c'era scritto prima di cancellarlo, nel caso servisse tornare indietro.",
    },
  },

  // ── Quanto ci mette ────────────────────────────────────────────────────────
  propagacion: {
    titulo: "Quanto ci mette a vedersi?",
    texto:
      "Cloudflare pubblica la modifica subito. Quello che ci mette è il resto di internet ad accorgersene: ogni computer tiene una copia della rubrica per un po', per non chiedere mille volte.",
    plazoNormal:
      "Con il TTL su «Auto», Cloudflare chiede che quella copia duri cinque minuti. In pratica, di solito funziona tra i cinque e i trenta minuti dopo aver salvato.",
    textoOtro:
      "Il tuo pannello pubblica la modifica in pochi minuti. Quello che ci mette è il resto di internet ad accorgersene: ogni computer tiene una copia della rubrica per un po', per non chiedere mille volte.",
    plazoNormalOtro:
      "Di solito funziona tra i dieci minuti e un'ora dopo aver salvato. Alcune aziende ci mettono di più a pubblicare la modifica: metti in conto fino a 24 ore prima di preoccuparti.",
    plazoMalo:
      "Se il tuo dominio mostrava già un altro sito, il tuo computer può metterci di più a lasciar andare quello che aveva in memoria. Non è un errore. Metti in conto 24 ore prima di preoccuparti.",
    truco:
      "Un trucco per non impazzire a guardare: aprilo in una finestra in incognito, oppure dal telefono con i dati al posto del wifi. Così vedi quello che vede un cliente nuovo, non quello che ha in memoria il tuo computer.",
    dominioNuevo:
      "A parte: se hai appena aggiunto il dominio a Cloudflare per la prima volta, Cloudflare ci mette fino a 24 ore a darlo per attivo. Fino ad allora tutto funziona come se le nuvole fossero grigie, anche se le vedi arancioni. Aspetta che il dominio dica «Attivo» («Active») prima di dare qualcosa per sbagliato.",
    ssl:
      "Quando la verifica va a buon fine, rilasciamo il lucchetto di sicurezza. Sono altri pochi minuti. Finché non finisce, il browser può avvisare che il sito non è sicuro: è normale e passa da solo.",
  },

  // ── Paso 3 ─────────────────────────────────────────────────────────────────
  paso3: {
    titulo: "Adesso verifichiamo",
    descripcion:
      "Guardiamo il tuo dominio e ti diciamo cosa troviamo. Se manca qualcosa, ti diciamo cos'è e come si sistema.",
    boton: "Verifica adesso",
    botonReintentar: "Verifica di nuovo",
    comprobando: "Stiamo guardando i tuoi record…",
    comprobandoAyuda: "Ci vogliono pochi secondi.",

    resultado: {
      registroOk: "L'annotazione nel DNS c'è e punta a noi",
      registroKo: "Ancora non vediamo l'annotazione",
      proxyOk: "La nuvola è grigia, come deve essere",
      proxyKo: "La nuvola è arancione",
      sslOk: "Lucchetto di sicurezza rilasciato",
      sslPendiente: "Stiamo rilasciando il lucchetto di sicurezza…",
      webOk: "Il tuo sito si apre su {dominio}, con il lucchetto",
      webActivando:
        "Stiamo attivando il tuo sito sul tuo dominio, con il suo lucchetto di sicurezza",
      webDespues: "Poi verifichiamo che il tuo sito si apra, con il lucchetto",
    },

    activando: {
      titulo: "Il tuo dominio adesso punta bene. Stiamo attivando il tuo sito",
      texto:
        "Manca solo il lucchetto di sicurezza, che si rilascia da solo e di solito ci mette uno o due minuti. Non cambiare niente su {panel}: lo verifichiamo noi e qui vedrai quando è pronto.",
    },

    exito: {
      titulo: "Fatto, il tuo sito adesso è su {dominio}",
      texto:
        "Puoi scrivere l'indirizzo nel browser e vederlo. Il vecchio indirizzo {actual} continua a funzionare, quindi i link che avevi già dato in giro non si rompono.",
      verWeb: "Vedi il mio sito",
      soloWww: "Il tuo sito si apre all'indirizzo con «www». Se vuoi che funzioni anche senza «www», chiedi al tuo provider di dominio un reindirizzamento all'indirizzo con «www», oppure un record ALIAS/ANAME sulla radice se il pannello lo consente.",
      copiarEnlace: "Copia l'indirizzo",
      siguiente:
        "Adesso mettilo nei tuoi profili di Booking, Airbnb, Instagram e nella firma della tua email.",
    },

    pendiente: {
      titulo: "Non è ancora pronto, ed è normale",
      texto:
        "Se l'hai appena salvato su {panel}, dagli qualche minuto e riprova. Non serve che resti qui: ti avvisiamo via email appena è pronto.",
      avisarme: "Avvisami via email quando è pronto",
    },
  },

  // ── Stati del dominio ──────────────────────────────────────────────────────
  estados: {
    sinConectar: "Non collegato",
    pendiente: "In attesa delle annotazioni",
    comprobando: "Verifica in corso",
    emitiendoSsl: "Rilascio del lucchetto",
    activo: "Funzionante",
    error: "Con un errore",
    activoAyuda: "Il tuo sito si vede su {dominio} e il collegamento è sicuro.",
    activandoAyuda:
      "Il tuo dominio adesso punta bene. Tra pochi minuti il tuo sito si aprirà su {dominio}, con il lucchetto.",
  },

  // ── Errori ─────────────────────────────────────────────────────────────────
  errores: {
    formatoInvalido: {
      titulo: "Questo non sembra un dominio",
      texto: "Scrivilo così: miodominio.com. Senza spazi e senza altro.",
    },
    conProtocolo: {
      titulo: "Il «https://» è di troppo",
      texto: "Toglilo e lascia solo il nome: {dominio}",
    },
    conRuta: {
      titulo: "È di troppo tutto quello che viene dopo la barra",
      texto: "Lascia solo la parte davanti: {dominio}",
    },
    sinExtension: {
      titulo: "Manca la terminazione",
      texto:
        "Un dominio finisce in .com, .it, .net… Controlla che non sia rimasto a metà.",
    },
    dominioNoExiste: {
      titulo: "Quel dominio non esiste",
      texto:
        "Non risulta registrato nessuno con quel nome. Ricontrolla come l'hai scritto. Se l'hai appena comprato, aspetta qualche ora e riprova.",
    },
    dominioCaducado: {
      titulo: "Quel dominio sembra scaduto",
      texto:
        "Entra nell'azienda dove l'hai comprato e controlla che il rinnovo sia pagato. Finché è scaduto non si può collegare.",
    },
    yaUsadoOtraCuenta: {
      titulo: "Quel dominio è già collegato a un altro account",
      texto:
        "Un dominio può puntare a un posto solo alla volta. Se {dominio} è tuo, scrivici e lo scolleghiamo dall'altro account così lo puoi usare qui.",
      contactar: "Scrivi all'assistenza",
    },
    yaUsadoEstaCuenta: {
      titulo: "Ce l'hai già collegato",
      texto:
        "{dominio} è in uso su «{sitio}». Scollegalo da lì oppure scegli un altro indirizzo per questo sito.",
    },
    registrosNoAparecen: {
      titulo: "Ancora non vediamo niente sul tuo dominio",
      texto:
        "Di solito è questione di minuti: l'hai appena salvato e non è ancora arrivato dappertutto. Aspetta dieci minuti e clicca di nuovo su «Verifica».",
      repasa: "Se è già passata mezz'ora, ricontrolla tre cose su {panel}:",
      repasa1: "Che in «Nome» hai messo {nombre} e non il dominio per intero.",
      repasa2: "Che hai cliccato su «Salva» («Save») e la riga compare nell'elenco.",
      repasa3: "Che l'hai scritta su {dominio} e non su un altro dominio del tuo account.",
    },
    proxyActivado: {
      titulo: "La nuvola arancione è attiva",
      texto:
        "Vediamo il tuo dominio, ma passa dal proxy di Cloudflare e questo ci nasconde la destinazione vera. Finché resta arancione, non possono funzionare né la verifica né il lucchetto di sicurezza.",
      solucion:
        "Entra in «DNS» → «Record», cerca la riga con il nome {nombre}, clicca sulla nuvola arancione finché non diventa grigia e dice «Solo DNS» («DNS only»), e salva. Poi torna qui e clicca su «Verifica».",
    },
    apuntaOtroSitio: {
      titulo: "Il tuo dominio punta da un'altra parte",
      texto:
        "Abbiamo trovato {encontrado} e ci aspettavamo {destino}. Quasi sempre è una vecchia annotazione del sito precedente rimasta lì.",
      solucion:
        "In «DNS» → «Record», cancella la vecchia riga che ha il nome {nombre} e lascia solo la nostra.",
    },
    destinoAntiguo: {
      titulo: "Il valore che ti avevamo dato prima non funzionava",
      texto:
        "La tua annotazione porta a {encontrado}, che è quello che ti indicavamo, ma quell'indirizzo non funziona. L'errore è stato nostro, non tuo.",
      solucion:
        "Su {panel}, modifica l'annotazione {nombre} e metti come valore {destino}. Il TXT lascialo com'è.",
    },
    registroDuplicado: {
      titulo: "Ci sono due annotazioni per lo stesso nome",
      texto:
        "Un nome non può portare a due posti. Cancella quella che non è la nostra e verifica di nuovo.",
    },
    error1014: {
      titulo: "Se il browser mostra «Error 1014»",
      texto:
        "È un'altra faccia del solito problema: la nuvola arancione. Mettila in grigio («Solo DNS») e sparisce.",
    },
    sslFallido: {
      titulo: "Non siamo riusciti a rilasciare il lucchetto di sicurezza",
      texto:
        "L'annotazione nel DNS è giusta, ma il lucchetto non esce. Di solito è di nuovo la nuvola arancione, oppure una vecchia annotazione che ci intralcia. Riprova tra un po'; se resta così, scrivici e ce ne occupiamo noi.",
      reintentar: "Riprova il rilascio",
    },
    sinPermisos: {
      titulo: "Non puoi cambiare il dominio",
      texto: "Chiedilo al responsabile dell'account.",
    },
    servidor: {
      titulo: "Non siamo riusciti a verificarlo adesso",
      texto: "Qualcosa non ha funzionato da parte nostra. Riprova tra qualche minuto.",
    },
    guardar: "Non è stato possibile salvare il dominio. Riprova.",
  },

  // ── Scollegare ─────────────────────────────────────────────────────────────
  desconectar: {
    boton: "Scollega questo dominio",
    titulo: "Scollegare {dominio}?",
    texto:
      "Il tuo sito non si vedrà più su {dominio} e tornerà a vedersi solo su {actual}. Chi scrive il tuo dominio non troverà niente finché non lo fai puntare da un'altra parte.",
    aviso:
      "Le annotazioni che hai fatto su {panel} restano lì. Cancellale tu se non le vuoi più.",
    cancelar: "Annulla",
    confirmar: "Scollega",
    hecho: "Dominio scollegato.",
  },

  // ── Dubbi ──────────────────────────────────────────────────────────────────
  dudas: {
    titulo: "Dubbi che vengono sempre",

    correoPregunta: "Questo mi fa saltare l'email di @{dominio}?",
    correoTexto:
      "No. L'email passa da altre righe della rubrica, quelle di tipo MX, e noi non le tocchiamo. Finché non cancelli quelle, la tua email resta com'è.",

    otraWebPregunta: "Ho un altro sito su quel dominio. Che fine fa?",
    otraWebTexto:
      "Non si vede più: il dominio passa a mostrare questo. Se vuoi tenerli tutti e due, usa un indirizzo a parte come prenotazioni.{dominio} per quello di WACheckin.",

    volverAtrasPregunta: "Posso tornare indietro?",
    volverAtrasTexto:
      "Sì, quando vuoi. Si disfa dove è stato fatto: cancelli l'annotazione su {panel} e rimetti quella che avevi prima. Ci mette lo stesso tempo a farsi notare, qualche minuto.",

    wwwPregunta: "Funzionerà con e senza «www»?",
    wwwTexto:
      "Sì, se metti le due righe che ti diamo. Una comanda e l'altra rimanda alla prima, così Google non vede due siti uguali.",

    costePregunta: "Mi costa qualcosa?",
    costeTexto:
      "Collegarlo no. Il dominio continui a pagarlo dove l'hai comprato, come sempre.",

    quienPregunta: "Non me la sento di fare questa cosa.",
    quienTexto:
      "Normale, è la parte più noiosa di tutto il percorso. Scrivici indicando il tuo dominio e lo facciamo insieme a te al telefono in dieci minuti.",
  },

  // ── Pulsanti ───────────────────────────────────────────────────────────────
  botones: {
    atras: "Indietro",
    siguiente: "Avanti",
    guardar: "Salva",
    guardando: "Salvataggio…",
    cerrar: "Chiudi",
    entendido: "Ho capito",
    abrirCloudflare: "Apri Cloudflare",
    soporte: "Voglio l'aiuto di WACheckin",
    verGuia: "Rivedi la guida",
  },

  avisos: {
    copiado: "Copiato negli appunti",
    copiadoError: "Non è stato possibile copiare. Selezionalo a mano.",
    guardado: "Dominio salvato. Adesso tocca fare le annotazioni su {panel}.",
    conectado: "Il tuo sito adesso si vede su {dominio}!",
    correoEnviado: "Ti abbiamo mandato le istruzioni via email.",
  },
};
